<template>
  <b-row>
    <b-col>
      <b-card :class="{ open: visibleBody }" style="margin:0">
        <b-card-header
          :class="{ collapsed: !visibleBody }"
          role="tab"
          @click="onVisibleBody()"
          style="background-color: #0080C9; color: white; font:45px; padding: 15px; cursor: pointer;"
        >
          <span class="lead collapse-title"><strong>ANAMNESIS</strong></span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >

          <b-card-body style="margin:0; border:1px solid #2980b9;">

            <!-- <span>{{ tokenAtencion }}</span> -->

            <div class="row d-flex align-items-center" style="position: relative;">
              <b-col class="col-12">
                <strong>TIPO CONSULTA:</strong>
              </b-col>

              <CommentEditor
                v-if="isAuditoria"
                field="tipoConsulta"
                :comentarios="comentarios"
              />

              <b-col class="col-7 mx-1">
                {{ tipoConsultaText }}
                <span class="text-warning" v-if="!tipoConsultaText">No registra informacion</span>
              </b-col>

            </div>

            <hr class="divider-item">

            <div class="row d-flex align-items-center">
              <b-col class="col-12">
                <strong>MOTIVO CONSULTA:</strong>
              </b-col>

              <CommentEditor
                v-if="isAuditoria"
                field="motivoConsulta"
                :comentarios="comentarios"
              />

              <b-col class="col-12 mx-1">
                {{anamnesis.motivoConsulta}}
                <span class="text-warning" v-if="!anamnesis.motivoConsulta">No registra informacion</span>
              </b-col>
              
            </div>

            <hr class="divider-item">

            <div>
              <SemiologiasMain   
                v-if="tokenAtencion"          
                :tokenAtencion="tokenAtencion"
                :isAuditoria="isAuditoria"
              />
              <hr class="divider-item"/>
            </div>


            <div class="row d-flex align-items-center" style="position: relative;">
              <b-col class="col-12">
                <strong>ANTECEDENTES PERSONALES:</strong>
              </b-col>

              <CommentEditor
                v-if="isAuditoria"
                field="antPersonales"
                :comentarios="comentarios"
              />

              <AntPersonalesTable
                v-model="hasAntPersonalesData"
                :tokenAtencion="tokenAtencion"
              />

              <div 
                v-if="!hasAntPersonalesData"
                class="col mx-1 text-warning" 
              >
                No registra informacion
              </div>

            </div>

            <hr class="divider-item">

            
            <div v-if="esGinecologia" class="row d-flex align-items-center" style="position: relative;">
              <b-col class="col-12">
                <strong>ANTECEDENTES GINECOLOGICOS:</strong>
              </b-col>            
              <AntGinecologicosTable :tokenAtencion="tokenAtencion"/>             
               
            </div>
            <hr v-if="esGinecologia" class="divider-item">

            <div class="row d-flex align-items-center" style="position: relative;">
              <b-col class="col-12">
                <strong>ANTECEDENTES FAMILIARES:</strong>
              </b-col>

              <CommentEditor
                v-if="isAuditoria"
                field="antFamiliares"
                :comentarios="comentarios"
              />

              <AntFamiliaresTable
                v-model="hasAntFamiliaresData"
                :tokenAtencion="tokenAtencion"
              />

              <div 
                class="col mx-1 text-warning" 
                v-if="!hasAntFamiliaresData"
              >
                No registra informacion
              </div>

            </div>

            <hr class="divider-item">

            <div class="row d-flex align-items-center" style="position: relative;">
              <b-col class="col-12">
                <strong>REVISION DE ORGANOS:</strong>
              </b-col>

              <CommentEditor
                v-if="isAuditoria"
                field="revOrganos"
                :comentarios="comentarios"
              />

              <RevOrganosTable
                v-model="hasRevOrganosData"
                :tokenAtencion="tokenAtencion"
              />

              <div class="col mx-1 text-warning" v-if="!hasRevOrganosData">No registra informacion</div>
            </div>

            <hr class="divider-item">

            <div class="row d-flex align-items-center" style="position: relative;">
              <b-col class="col-12">
                <strong>EXAMEN FISICO:</strong>
              </b-col>

              <CommentEditor
                v-if="isAuditoria"
                field="examenFisico"
                :comentarios="comentarios"
              />

              <ExamFisicoTable
                v-model="hasExamenFisicoData"
                :tokenAtencion="tokenAtencion"
              />

              <div class="col mx-1 text-warning" v-if="!hasExamenFisicoData">No registra informacion</div>
            </div>

            <hr class="divider-item">

            <div class="row d-flex align-items-center">
              <b-col class="col-12">
                <strong>DIAGNOSTICOS:</strong>
              </b-col>

              <CommentEditor
                v-if="isAuditoria"
                field="diagnosticos"
                :comentarios="comentarios"
              />

              <b-col class="col-12 mx-1">
                <span 
                  class="text-warning" 
                  v-if="diagnosticos.length === 0"
                >
                  No registra informacion
                </span>
              </b-col>

              <DiagnosticosList 
                v-if="diagnosticos.length > 0"
                v-model="diagnosticos"
                onlyView noTitle noBorder
                class="my-1 col-12"
              />

            </div>

            <hr class="divider-item">

            <div class="row d-flex align-items-center">
              <b-col class="col-12">
                <strong>PROBLEMA ACTUAL:</strong>
              </b-col>

              <CommentEditor
                v-if="isAuditoria"
                field="problemaActual"
                :comentarios="comentarios"
              />

              <b-col class="col-12 mx-1">
                {{anamnesis.problemaActual}}
                <span class="text-warning" v-if="!anamnesis.problemaActual">No registra informacion</span>
              </b-col>

              
            </div>

            <hr class="divider-item">

            <div class="row d-flex align-items-center">
              <b-col class="col-12">
                <strong>PLAN DE TRATAMIENTO:</strong>
              </b-col>

              <CommentEditor
                v-if="isAuditoria"
                field="planTratamiento"
                :comentarios="comentarios"
              />

              <b-col class="col-12 mx-1">
                {{anamnesis.planTratamiento}}
                <span class="text-warning" v-if="!anamnesis.planTratamiento">No registra informacion</span>
              </b-col>

            </div>

          </b-card-body>

        </b-collapse>
      </b-card>
    </b-col>

  </b-row>
</template>

<script>
import { DiagnosticosList } from '@/shared/components';
import SemiologiasMain         from '@/views/atencionCita/components/Anamnesis/Semiologias/SemiologiasMain.vue';
import AntPersonalesTable   from '../AntPersonalesTable/AntPersonalesTable.vue';
import AntFamiliaresTable   from '../AntFamiliaresTable/AntFamiliaresTable.vue';
import RevOrganosTable      from '../RevOrganosTable/RevOrganosTable.vue';
import ExamFisicoTable      from '../ExamFisicoTable/ExamFisicoTable.vue';
import { anamnesisService, diagnosticosService } from '../../services';

import CommentEditor from '../CommentEditor/CommentEditor.vue';
import AntGinecologicosTable from '../AntPersonalesTable/AntGinecologicosTable.vue';


export default {

  name: "AtencionAnamnesis",

  props: {

    isAuditoria: {
      type: Boolean,
      default: false
    },
  
    tokenAtencion:{
      type: String,
      required: true
    }
  },

  components: {
    DiagnosticosList,
    CommentEditor,
    AntPersonalesTable,
    AntFamiliaresTable,
    RevOrganosTable,
    ExamFisicoTable,
    AntGinecologicosTable,
    SemiologiasMain
  },


  data() {
    return {
      visibleBody: false,
      esGinecologia:false,
      anamnesis: {},

      comentarios:{},

      diagnosticos: [],

      hasAntPersonalesData  : false,
      hasAntFamiliaresData  : false,
      hasAntGinecologicosData  : false,
      hasRevOrganosData     : false,
      hasExamenFisicoData   : false,
    }
  },


  created() {
    this.onGetData();
  },

  methods: {

    onVisibleBody() {
      this.visibleBody = !this.visibleBody
    },


    async onGetData(){
      const data = await anamnesisService.getByAtencion(this.tokenAtencion);
      

      if (!data) return;
      this.anamnesis = data;

      if (data.especialidad.codEsp === '0000000148'){this.esGinecologia = true}

      const diagnosticosData = await diagnosticosService.getByAtencion( this.tokenAtencion );
      if( !diagnosticosData ) return;
      const diagnosticosActivos = diagnosticosData.filter( d => d.activo );
      this.diagnosticos = diagnosticosActivos;
    },

    onSaveComment(field){
      this.$set(this.comentarios, field, { edit:true, text:null });
    },

    onRemoveComment(field){
      this.$set(this.comentarios, field, null);
    }
    
  },

  computed: {

    tipoConsultaText() {
      return this.anamnesis?.tipoConsulta?.descripcion;
    },

  },

  watch: {

    tokenAtencion: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.onGetData();
      }
    },

    comentarios:{
      deep: true,
      handler(newValue) {
        console.log('comentarios', newValue);

        this.$store.commit("setComentarios", { anamnesis: this.comentarios });

        this.$store.commit("setRevisiones", {
          tokenAtencion: this.tokenAtencion,
          data: { anamnesis: newValue }
        });
      }
    }
  }

};
</script>


<style>
 .divider-item {
   border-top: 1px solid #0066a1;
   margin-top: 2rem;
   margin-bottom: 2rem;
 }
</style>